<script>
  export let color_list;
</script>

<div class="container" style="margin-left:10px;">
  <div class="col">
    <div class="row">
      <div class="small-box" style="background-color: {color_list[0]}" />
      New Leads
    </div>

    <div class="row">
      <div class="small-box" style="background-color: {color_list[1]}" />
      New OPPs
    </div>

    <div class="row">
      <div class="small-box" style="background-color: {color_list[2]}" />
      New CUST
    </div>

    <div class="row">
      <div class="small-box" style="background-color: {color_list[3]}" />
      Sold BOLUSES
    </div>
  </div>
</div>

<style>
  .small-box {
    width: 6px;
    height: 6px;
    padding: 0px;
    margin-top: 3px;
    margin-right: 7px;
  }
  div {
    font-size: 8px !important;
  }
</style>
